
// import rtHeaderButtonGroup from "./rtHeaderButtonGroup";
// import rtInput from "./rtInput";
import rtShareEntity from "./rtShareEntity";

let components = [
  //rt
  // {
  //   name: rtHeaderButtonGroup.name,
  //   component: rtHeaderButtonGroup
  // },
  {
    name: rtShareEntity.name,
    component: rtShareEntity
  },
  // {
  //   name: rtInput.name,
  //   component: rtInput
  // }
];

export default components;


// WEBPACK FOOTER //
// ./src/components/index.js